import React from 'react';

import { Button } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { PageTitle } from '../../../../shared/components/ui-components';
import { entityListStore } from '../../../stores/entityListStore';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { EntityListFilterTabs } from './EntityListFilterTabs/EntityListFilterTabs';
import { LIST_MODE, ListMode } from '../NgzEntityList.settings';

type EntityListPageTitleProps = {
  listMode: ListMode;
};

const EntityListPageTitle = observer(({ listMode }: EntityListPageTitleProps) => {
  const { filteredEntityCount } = entityListStore;
  const { isSuperAdmin } = loggedInUserDataStore;

  const addEntityPathConfig: Record<ListMode, string> = {
    [LIST_MODE.NUTRITION]: '#!/nutrition/entity-setup-flow-2024',
    [LIST_MODE.SCAN_IQ]: '#!/scan-iq/entity-setup-flow-2024',
  };

  const addEntityPath = addEntityPathConfig[listMode];

  return (
    <PageTitle
      title={`Entities (${filteredEntityCount})`}
      tabs={<EntityListFilterTabs listMode={listMode} />}
    >
      {isSuperAdmin && (
        <Button variant="contained" size="medium" href={addEntityPath}>
          Add a New Entity
        </Button>
      )}
    </PageTitle>
  );
});

export { EntityListPageTitle };
